import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchCountries,
  filterByRegion,
  loadMore,
} from '../redux/countriesSlice';
import {
  Container,
  Row,
  Col,
  ButtonGroup,
  Button,
  Card,
  Carousel,
  Spinner,
  Dropdown,
} from 'react-bootstrap';
import {
  FaArrowLeft,
  FaArrowRight,
  FaFacebook,
  FaXTwitter,
  FaLinkedin,
  FaYoutube,
  FaEllipsisVertical,
} from 'react-icons/fa6';
import image from '../assets/carousal.png';
import './Home.css';

const Home = () => {
  const [index, setIndex] = useState(0);

  const dispatch = useDispatch();
  const { filtered, visible, status, region } = useSelector(
    (state) => state.countries
  );

  useEffect(() => {
    dispatch(fetchCountries());
  }, [dispatch]);

  const handleFilter = (r) => dispatch(filterByRegion(r));

  const topCountries = filtered.slice(0, 5);
  const carouselImages = topCountries.slice(0, 4).map((c) => c.flag);

  return (
    <>
      {/* Header */}
      <Container
        fluid
        className="header-wrapper py-3 bg-white px-lg-5"
      >
        <Row className="align-items-center justify-content-between px-3">
          <Col xs="auto">
            <h4 className="mb-0 fw-bold" style={{ fontSize: "30px" }}>Countries</h4>
          </Col>

          {/* Desktop Filters */}
          <Col xs="auto" className="d-none d-md-block">
            <ButtonGroup className="filter-buttons">
              {['All', 'Asia', 'Europe'].map((r) => (
                <Button
                  key={r}
                  variant="link"
                  className={`filter-btn ${region === r ? 'active' : ''}`}
                  onClick={() => handleFilter(r)}
                >
                  {r}
                </Button>
              ))}
            </ButtonGroup>
          </Col>

          {/* Mobile Dropdown */}
          <Col xs="auto" className="d-md-none">
            <Dropdown>
              <Dropdown.Toggle variant="link" className="p-0 border-0 text-dark">
                <FaEllipsisVertical size={20} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {['All', 'Asia', 'Europe'].map((r) => (
                  <Dropdown.Item
                    key={r}
                    active={region === r}
                    onClick={() => handleFilter(r)}
                  >
                    {r}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
      </Container>

      {/* Welcome Section */}
      <Container fluid className="welcome-container text-center my-5 p-0">
        <Row className="align-items-center justify-content-center">
          <Col xs={12} md={4}><div className="line left-line" /></Col>
          <Col xs={12} md="auto"><div className="welcome-text">Welcome</div></Col>
          <Col xs={12} md={4}><div className="line right-line" /></Col>
        </Row>
      </Container>

      {/* Carousel Section */}
      <Container fluid style={{ paddingLeft: '7rem', paddingRight: '7rem' }}
        className="mt-5
">
        <Row className="justify-content-between">
          <Col md={9} className="mb-3">
            <div className="position-relative border border-3 border-dark carousel-wrapper">
              <Carousel
                controls={false}
                indicators={false}
                activeIndex={index}
                onSelect={(selectedIndex) => setIndex(selectedIndex)}
                interval={3000}
              >
                {carouselImages.map((img, idx) => (
                  <Carousel.Item key={idx}>
                    <img
                      src={img}
                      alt={`Slide ${idx + 1}`}
                      className="d-block w-100 carousel-image"
                    />
                  </Carousel.Item>
                ))}
              </Carousel>

              {/* Arrows + Dots */}
              <div className="custom-carousel-controls">
                <FaArrowLeft
                  onClick={() =>
                    setIndex(index === 0 ? carouselImages.length - 1 : index - 1)
                  }
                  className="custom-arrow"
                />
                <div className="custom-dots">
                  {carouselImages.map((_, i) => (
                    <div
                      key={i}
                      onClick={() => setIndex(i)}
                      className={`dot ${index === i ? 'active' : ''}`}
                    />
                  ))}
                </div>
                <FaArrowRight
                  onClick={() =>
                    setIndex(index === carouselImages.length - 1 ? 0 : index + 1)
                  }
                  className="custom-arrow"
                />
              </div>
            </div>
          </Col>

          {/* Right Static Image */}
          <Col md={3}>
            <div className="border border-3 border-dark right-image-wrapper">
              <img
                src={image}
                alt="Side"
                className="right-image"
              />
            </div>
          </Col>
        </Row>
      </Container>

      {/* Country Cards */}
      <Container className="mt-5">
        <Row>
          {status === 'loading' ? (
            <Col className="text-center">
              <Spinner animation="border" />
            </Col>
          ) : (
            filtered.slice(0, visible).map((country) => (
              <Col key={country.name} xs={12} md={6} className="mb-3 fw-bold">
                <Card className="h-100 p-3 border border-3 border-dark rounded-0 card-shadow">
                  <Row className="align-items-center h-100">
                    <Col xs={4} className="text-center">
                      <div className="flag-wrapper">
                        <img src={country.flag} alt={`${country.name} flag`} />
                      </div>
                    </Col>
                    <Col xs={8}>
                      <h5 className="mb-1 fw-bold">{country.name}</h5>
                      <small className="text-muted">{country.region}</small>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))
          )}
        </Row>

        {/* Load More */}
        {visible < filtered.length && (
          <div className="text-center my-4">
            <Button
              className="rounded-0"
              style={{ fontSize: '14px' }}
              onClick={() => dispatch(loadMore())}
              variant="dark"
            >
              Load More
            </Button>
          </div>
        )}
      </Container>

      {/* Footer */}
      <footer className="text-center py-5 footer-section">
        <div className="d-flex justify-content-center gap-4 mb-3">
          <a href="#" className="social-icon"><FaFacebook /></a>
          <a href="#" className="social-icon"><FaXTwitter /></a>
          <a href="#" className="social-icon"><FaLinkedin /></a>
          <a href="#" className="social-icon"><FaYoutube /></a>
        </div>
        <p className="mb-1 fw-semibold">Example@email.com</p>
        <p className="mb-0 text-muted">&copy; 2020 Name. All rights reserved.</p>
      </footer>
    </>
  );
};

export default Home;
